import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Button } from 'antd';

const TABLE_BORDER = '1px solid #0000004a';

const styles = theme => ({
  tableGridWrapper: {
    backgroundColor: 'gray',
  },
  tableGrid: {
    display: 'grid',
    marginTop: '20px',
    marginBottom: '20px',
    backgroundColor: 'white',
  },
  divider: {
    gridColumn: '1 / -1',
    borderBottom: TABLE_BORDER,
    width: '100%',
  },
  inProgress: {
    color: '#E27500',
  },
  notStarted: {
    color: theme.colors.textTertiary,
  }
});

const SETaskBlockerModal = ({
  classes,
  visible,
  onCancel,
  data,
  renderHeader = () => <div>The following tasks need to be completed before this is marked done. </div>,
  columns = ['Task Name', "Current Status"],
  title = 'Attention',
}: {
  [key: string]: any,
}) => {
  const handleCancel = () => onCancel();

  const Divider = () => <div className={classes.divider} />;

  const ModalFooter = () => {
    return <Button type="primary" onClick={handleCancel} style={{ width: 80 }}>
        Ok
        </Button>;
  };

  const TableCell = ({
    children,
    leftBoundary = false,
    topBoundary = false,
    rightBoundary = false,
    className = '',
  }) => {
    return <span className={className} style={{
      padding: '10px',
      borderLeft: leftBoundary ? TABLE_BORDER : '',
      borderRight: rightBoundary ? TABLE_BORDER : '',
      backgroundColor: topBoundary ? '#F6F8FC' : 'white',
    }}> {children} </span>;
  };

  const TableTitles = () => {
    return <>
      <Divider />
      {columns.map((col, idxC) =>
        TableCell({ leftBoundary: true, topBoundary: true, rightBoundary: idxC + 1 === columns.length, children: [col] })
      )}
      <Divider />
    </>;
  };

  const TableRows = () => {
    return <>
      {data.map((task, idxR) => {
        return <>
          {TableCell({ leftBoundary: true, children:[task.name] })}
          {TableCell({ leftBoundary: true, rightBoundary: true,
            className: `${task.status === 'In Progress' ? classes.inProgress : classes.notStarted}`,
            children: [task.status] })}
          {idxR === data.length - 1 && <Divider />}
        </>;
      })}
    </>;
  };

  const ComparisonTable = () => {
    return <div className={classes.tableGridWrapper}>
      <div className={classes.tableGrid}
        style={{ gridTemplateColumns: `repeat(${columns.length}, auto)` }}>
        {TableTitles()}
        {TableRows()}
      </div>
    </div>;
  };

  return <div>
    <Modal
      visible={visible}
      onCancel={handleCancel}
      title={title}
      footer={ModalFooter()}>
      {renderHeader()}
      {ComparisonTable()}
    </Modal>
  </div>;
};

export default React.memo(
  injectSheet(styles)(SETaskBlockerModal),
);
